import {
  __,
  compose,
  defaultTo,
  find,
  includes,
  prop,
  propEq,
  propOr,
  propSatisfies,
  complement,
} from 'ramda';

const orderItems = propOr([], 'orderItems');
const propNotEq = complement(propEq);

export const gameOrderItem = compose(
  find(propEq('type', 'GameOrderItem')),
  orderItems
);

export const orderItemGame = compose(
  prop('game'),
  defaultTo({}),
  find(
    propSatisfies(includes(__, ['GameBetOrderItem', 'GameOrderItem']), 'type')
  ),
  orderItems
);

export const isOptionalBetOrder = compose(
  propEq('paymentPlan', 'optional'),
  defaultTo({}),
  gameOrderItem
);

export const isNotUpfrontOrder = compose(
  propNotEq('paymentPlan', 'upfront'),
  defaultTo({}),
  gameOrderItem
);

export const isGameBetOrder = propEq('type', 'GameBetOrder');
